import { useQuery } from "@tanstack/react-query";
import useOrganizationId from "customHooks/useOrganizationId";
import { callApiV2 } from "util/apiCaller";

export const RQ_TOTAL_CUSTOMER_COUNT = "RQ_TOTAL_CUSTOMER_COUNT";

const fetchTotalCustomerCount = async ({ orgId }) => {
  const res = await callApiV2({
    method: "post",
    endpoint: `v1/organizations/${orgId}/customers/count/`,
    body: [],
    shouldUseCampaignDomain:
      orgId &&
      [
        "454407b2-41bb-45fc-b130-6c2bf146b783",
        "38a697d8-c2ce-4e94-812b-7ec688e27100",
        "95bca1d3-4565-4ca8-93ff-dabccd505fde", // paisabazaar
        "2bebc2a4-a54e-4b31-99ce-e1dbc75be18c", // paisabazaar
      ].includes(orgId),
  });

  if (res?.result) {
    return res.data;
  }
  throw new Error(res.message);
};

const useTotalCustomerCount = ({
  select = (data) => data,
  options = {},
} = {}) => {
  const orgId = useOrganizationId();

  return useQuery(
    [RQ_TOTAL_CUSTOMER_COUNT, orgId],
    () => fetchTotalCustomerCount({ orgId }),
    {
      select,
      ...options,
      enabled:
        options.enabled === undefined ? !!orgId : !!options.enabled && !!orgId,
    },
  );
};

export default useTotalCustomerCount;
